import type { InitialStoreType } from './store';

// re-export for backwards compatibility
export { APP_STORE } from './store';

export type StoreType = InitialStoreType;

// https://redux.js.org/usage/usage-with-typescript#define-root-state-and-dispatch-types
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<StoreType['getState']>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = StoreType['dispatch'];

// Update DefaultRootState per redux-react:
// This interface can be augmented by users to add default types for the root state when using react-redux.
// Use module augmentation to append your own type definition in a your_custom_type.d.ts file.
// https://www.typescriptlang.org/docs/handbook/declaration-merging.html#module-augmentation
declare module 'react-redux' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultRootState extends RootState {}
}
